module.exports = __webpack_public_path__ + "static/img/moreClassification.6da6c23.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/moreClassification.svg
// module id = IuuX
// module chunks = 0